// extracted by mini-css-extract-plugin
export default {"errorMessage":"generic-delete-modal-module__errorMessage--EaMkW"};